import apiClient from '@u/apiClient'
import UpdateDiaryChiftAccountingLinkController from '@/wayfinder/actions/App/Http/Controllers/Partner/ChiftAccounting/UpdateDiaryChiftAccountingLinkController'

export default {
  updateAccountingDiaryChiftAccountingLink(_, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDiaryChiftAccountingLinkController.put({
            accounting_diary: payload.id
          }),
          {
            enabled: payload.enabled
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
